var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderDelayed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 41,
    r: 20.5,
    fill: "#FFFAEC",
    stroke: "#BF8A05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.332 50.33H44.333a.667.667 0 0 1-.666-.666v-2H43v2c0 .736.597 1.333 1.333 1.333h12c.565 0 1.068-.356 1.256-.889l-.627-.222a.669.669 0 0 1-.63.445z",
    fill: "#BF8A05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.666 38v-3.334c0-.007-.004-.013-.004-.02a.333.333 0 0 0-.018-.087l-.01-.03a.334.334 0 0 0-.067-.098l-3.333-3.333a.33.33 0 0 0-.216-.095c-.005 0-.011-.003-.019-.003h-9.666c-.736 0-1.333.597-1.333 1.333v15.375h.667V32.333c0-.368.298-.666.666-.666h9.333v2c0 .736.597 1.333 1.333 1.333h2v3h.667zm-2.667-3.667a.667.667 0 0 1-.666-.666v-1.53l2.195 2.196H55z",
    fill: "#BF8A05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.332 40h2v1h-2v-1zM52.332 40h7v1h-7v-1zM48.332 43h2v1h-2v-1zM52.332 43h7v1h-7v-1zM48.332 46h2v1h-2v-1zM52.332 46h7v1h-7v-1z",
    fill: "#BF8A05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "m1q7b7u6wa",
    x: 0,
    y: 0,
    width: 102,
    height: 102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7294_2161"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7294_2161",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderDelayed);
export default __webpack_public_path__ + "static/media/order_delayed.2f7c3b6748a0dd535515cf3a11e51059.svg";
export { ForwardRef as ReactComponent };